// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
    text-align: center;
    margin-bottom: 1rem;

    font-size: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Heading/heading.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;;IAEnB,eAAe;AACnB","sourcesContent":["h2 {\n    text-align: center;\n    margin-bottom: 1rem;\n\n    font-size: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
